import PropTypes from 'prop-types'

import { classNames } from '../../helpers'

/**
 * Gruppen-Überschrift innerhalb einer Karte (KONTAKT, ZUR PERSON, ANHÄNGE …).
 *
 * Die explizite `text-[13px]`-Klasse ist Absicht: `tailwind.config.js` setzt
 * via `addBase` ein blankes `h3` auf `text-lg`.
 */
const GroupLabel = ({ as: Tag, children, className }) => (
  <Tag
    className={classNames(
      'text-[13px] font-bold uppercase tracking-wider text-gray-800',
      className
    )}
  >
    {children}
  </Tag>
)

GroupLabel.propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

GroupLabel.defaultProps = {
  as: 'h3',
  className: undefined
}

export default GroupLabel
